export default __webpack_public_path__ + "static/media/noSong.77860820.png";